/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Dispute resolution decision for competition matches
 * @export
 */
export const CompetitionDisputeDecision = {
    PARTICIPANT_1_WINS: 'PARTICIPANT_1_WINS',
    PARTICIPANT_2_WINS: 'PARTICIPANT_2_WINS',
    REMATCH: 'REMATCH',
    CANCELLED: 'CANCELLED'
} as const;
export type CompetitionDisputeDecision = typeof CompetitionDisputeDecision[keyof typeof CompetitionDisputeDecision];


export function instanceOfCompetitionDisputeDecision(value: any): boolean {
    for (const key in CompetitionDisputeDecision) {
        if (Object.prototype.hasOwnProperty.call(CompetitionDisputeDecision, key)) {
            if (CompetitionDisputeDecision[key as keyof typeof CompetitionDisputeDecision] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CompetitionDisputeDecisionFromJSON(json: any): CompetitionDisputeDecision {
    return CompetitionDisputeDecisionFromJSONTyped(json, false);
}

export function CompetitionDisputeDecisionFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionDisputeDecision {
    return json as CompetitionDisputeDecision;
}

export function CompetitionDisputeDecisionToJSON(value?: CompetitionDisputeDecision | null): any {
    return value as any;
}

export function CompetitionDisputeDecisionToJSONTyped(value: any, ignoreDiscriminator: boolean): CompetitionDisputeDecision {
    return value as CompetitionDisputeDecision;
}

